import { render, staticRenderFns } from "./SortingDropdown.vue?vue&type=template&id=398dfd68&scoped=true&"
import script from "./SortingDropdown.vue?vue&type=script&lang=js&"
export * from "./SortingDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SortingDropdown.vue?vue&type=style&index=0&id=398dfd68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398dfd68",
  null
  
)

export default component.exports